import { combineReducers } from 'redux';

import commonStoreReducer from './../../../../shared/components/react/CommonDataStore/reducer';

import * as Actions from './../actions/betfeedActionTypes';
import { initialState } from './../initialState';
import { getResetSelectedFilters } from './../utils';

import mainSocket from '../../../../shared/services/mainSocketClass';
import betfeedSocket from '../betfeedSocket';

import {
    BB_BETFEED_FILTER_ACTIVE_KEY,
    BB_BETFEED_FILTER_SELECTED_KEY,
    BB_BETFEED_FILTER_TYPE_SPORTS,
    BB_BETFEED_FILTER_TYPE_SORT_BY,
    BB_BETFEED_FILTER_TYPE_EVENT_STATUS,
    BB_BETFEED_FILTER_TYPE_BET_TYPE,
} from '../../constants';

/**
 * Main betfeed reducer
 * @todo some functionality here as placeholder - to be fleshed out when other stories are fleshed out.
 * @param {*} state the current state
 * @param {*} action the action
 * @returns {*} new state
 */
function betfeedReducer(state = initialState, action) {

    switch (action.type) {
        case Actions.BETFEED_WIDGET_SPORT_CHANGE: {
            return {
                ...state,
                sportSlug: action.sportSlug,
                sportName: action.sportName,
            };
        }
        case Actions.BETFEED_LOADING: {
            return { ...state, loadingState: action.status };
        }
        case Actions.BETFEED_LOADING_SUCCESS: {
            return { ...state, betCards: action.betCards.betcards };
        }
        case Actions.BETFEED_LOADING_ERROR: {
            return { ...state, errorOccurred: action.errorOccurred };
        }
        case Actions.BETFEED_START_LISTENING_FOR_WS_UPDATES: {
            mainSocket.startListeningForUpdates(action.betCards.betcards);

            return state;
        }
        case Actions.BETFEED_STOP_LISTENING_FOR_WS_UPDATES: {
            const { betCards } = action;
            const betCardsPayload = betCards.betcards || betCards;
            mainSocket.stopListeningForUpdates(betCardsPayload);

            return state;
        }
        case Actions.BETFEED_NEW_BETS:{
            return Object.assign({}, state, { isNewBets: action.status });
        }
        case Actions.BETFEED_ACTIVE_FILTER: {
            let active = action.active;
            if (!state.filter.filters[active]) {
                return { ...state };
            }

            if (state.filter.active === action.active) {
                active = 'none';
            }
            localStorage.setItem(BB_BETFEED_FILTER_ACTIVE_KEY, JSON.stringify(active));

            return { ...state, filter: { ...state.filter, active } };
        }
        case Actions.BETFEED_SELECT_FILTER_OPTION: {
            const selected = { ...state.filter.selected };
            let { filter: type, id } = action;


            let filter = state.filter.filters[type];

            if(type === BB_BETFEED_FILTER_TYPE_EVENT_STATUS.id || type === BB_BETFEED_FILTER_TYPE_BET_TYPE.id) {
                filter = state.filter.filters.betType[type];
            }


            if (!filter) {
                return { ...state };
            }

            if (type === BB_BETFEED_FILTER_TYPE_SORT_BY.id) {
                selected.sortBy = {
                    id,
                    ...filter[id],
                };
            } else if (type === BB_BETFEED_FILTER_TYPE_SPORTS.id) {
                selected.sports = { ...selected.sports };

                if (selected.sports[id]) {
                    delete selected.sports[id];
                } else {
                    selected.sports[id] = { ...filter[id] };
                }
            } else if (type === BB_BETFEED_FILTER_TYPE_EVENT_STATUS.id) {
                selected.eventStatus = { ...filter[id] };
            } else if (type === BB_BETFEED_FILTER_TYPE_BET_TYPE.id) {
                selected.betType = { ...filter[id] };
            }

            localStorage.setItem(BB_BETFEED_FILTER_SELECTED_KEY, JSON.stringify(selected));

            return { ...state, filter: { ...state.filter, selected } };
        }
        case Actions.BETFEED_SPORT_FILTERS: {
            return { ...state, filter: { ...state.filter, filters: {...state.filter.filters, sports: { ...action.sports } } } };
        }
        case Actions.BETFEED_RESET_FILTERS: {
            const currentFilters = { ...state.filter.selected };
            const storedFilters = JSON.parse(localStorage.getItem(BB_BETFEED_FILTER_SELECTED_KEY));
            const selected = getResetSelectedFilters(action.filter);
            const resetSelected = { ...currentFilters, ...storedFilters, ...selected };

            localStorage.setItem(BB_BETFEED_FILTER_SELECTED_KEY, JSON.stringify(resetSelected));

            return { ...state, filter: { ...state.filter, selected: resetSelected } };
        }
        case Actions.BETFEED_START_LISTENING_FOR_WS_NUMBER_OF_PEOPLE_BETTED_UPDATES: {
            betfeedSocket.startListeningForUpdates(action.betCards.betcards);

            return state;
        }
        case Actions.BETFEED_STOP_LISTENING_FOR_WS_NUMBER_OF_PEOPLE_BETTED_UPDATES: {
            const { betCards } = action;
            const betCardsPayload = betCards.betcards || betCards;
            betfeedSocket.stopListeningForUpdates(betCardsPayload);

            return state;
        }
        case Actions.BETFEED_NUMBER_OF_PEOPLE_BET_UPDATE_FROM_WEBSOCKET_EVENTS: {
            const betCards = [...state.betCards];
            const wsData = action.wsData;
            const one = 1;

            betCards.some((betcard, index) => {
                if (betcard.betcard_id === wsData.betcard_id) {
                    betCards[index] = {
                        ...betcard,
                        backing_customers: betcard.backing_customers + one,
                        user_included: wsData.user_has_bet ? wsData.user_has_bet : betcard.user_included,
                    };

                    return true;
                }

                return false;
            });

            return { ...state, betCards };
        }
        default:
            return state;
    }
}

export default combineReducers({
    betcards: betfeedReducer,
    commonData: commonStoreReducer,
});
